import { SDK } from '../helpers/sdk';
import type { FirestoreClientData } from '../interfaces';
import type { Email } from '@sda/interfaces/queue/email';

/**
 * Returns a FirestoreBaseClass instance for the message collection of the queue document
 * @return {SDK<Email>}
 */
export class Emails extends SDK<Email> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient);

    this.collection = this.fsh.Schema.EmailsQueue;
  }

  /**
   * Build an email message for sending into the queue
   * @return {Email}
   */
  build({
    to = null,
    from = process.env.SUPPORT_EMAIL_FULL,
    requestedFor = this.fsh.timestamp(),
    cc = null,
    bcc = null,
    replyTo = null,
    sendImmediately = false,
    showId = null,
    userId = null,
    notificationKey = null,
    headers = [],
    substitutions,
    template,
    attachments = [],
  }: Partial<Email>): Omit<Email, 'processedAt' | 'finalSubstitutions' | 'errorCode'> {
    return {
      to,
      from,
      bcc,
      cc,
      replyTo,
      substitutions,
      requestedFor,
      template,
      sendImmediately,
      showId,
      userId,
      headers,
      notificationKey,
      attachments,
      sentAt: null,
    };
  }

  /**
   * Add an email message to the email queue
   * @return {Promise<string>}
   */
  async addEmail(email: Partial<Email>): Promise<string> {
    return this.create(this.build(email));
  }
}
